export default __webpack_public_path__ + "static/media/icon_activity.svg.bak.7f9b2810.svg";